import type { SailPlotExtensionContext } from "@heiselanalytics/sailplot";
import { PageActions } from "./PageActions";

const SAILPLOT_SALES_URL = "/customize";

const copy = {
  en: {
    eyebrow: "Make your own SailPlot",
    title: "Your board. Your identity.",
    intro:
      "Bring your own logo, colors, URL, language, and links to SailPlot. Explore the branding and hosting packages on SailPlot.app.",
    action: "Explore branding & hosting",
    note: "The SailPlot editor remains open source. The annual packages cover your branding implementation and hosted SailPlot for twelve months.",
  },
  de: {
    eyebrow: "Dein eigenes SailPlot",
    title: "Dein Board. Dein Auftritt.",
    intro:
      "Bringe dein eigenes Logo, deine Farben, URL, Sprache und Links zu SailPlot. Entdecke die Branding- und Hosting-Pakete auf SailPlot.app.",
    action: "Branding & Hosting ansehen",
    note: "Der SailPlot-Editor bleibt Open Source. Die jährlichen Pakete umfassen deine Branding-Umsetzung und ein gehostetes SailPlot für zwölf Monate.",
  },
} as const;

export function MakeYourOwnPage({
  language,
  navigate,
}: SailPlotExtensionContext) {
  const text = copy[language];

  return (
    <article className="platform-page platform-reference-page platform-minimal-sales-page">
      <header>
        <span className="platform-page-eyebrow">{text.eyebrow}</span>
        <h1>{text.title}</h1>
        <p>{text.intro}</p>
      </header>
      <div className="platform-minimal-sales-action">
        <a
          className="customize-button customize-button--primary"
          href={SAILPLOT_SALES_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text.action} ↗
        </a>
        <small>{text.note}</small>
      </div>
      <PageActions language={language} navigate={navigate} />
    </article>
  );
}
